import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError,
} from './../feedingGuidelinesIntroAction';
import fetchApi from "./fetchApi";
import * as moment from 'moment';

function fetchFeedingGuidelinesIntro(state) {
  const casuistic = state.calculateDerReducer.data.casuistic;
  const data = getParams(casuistic, state);
  const queryString = Object.keys(data).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(data[k])}`).join('&');
  const breed = state.breedReducer.selectedType;

  return fetchApi(
    '/v1/fc_api/feeding_guidelines_intro_resource?' + queryString + '&casuistic=' + casuistic + '&breed=' + breed,
    fetchDataPending,
    fetchDataSuccess,
    fetchDataError
  );
}

/**
 * Get the additional params required for the intro component for the current casuistic
 */
function getParams(casuistic, state){
  let data = {};

  switch (casuistic){
    case "hospitalisation":
      data['ibw'] = state.bodyConditionReducer.selectedGoalWeight;
      data['cbw'] = state.bodyConditionReducer.selectedBodyWeight;
      data['der'] = state.calculateDerReducer.data.der;
      break;

    case "pregnancy":
      data['der'] = state.calculateDerReducer.data.der;
      data['number_weeks_pregnant'] = state.weeksLitterReducer.selectedWeeks;
      break;

    case "lactation":
      data['der'] = state.calculateDerReducer.data.der;
      data['number_weeks_lactation'] = state.weeksLitterReducer.selectedWeeks;
      data['age_in_weeks'] = getAgeInWeeks(state.birthDateReducer.selected);
      data['litter_size'] = state.weeksLitterReducer.selectedLitter;
      break;

    case "growth":
      data['der'] = state.calculateDerReducer.data.der;
      break;

    case "weight_adjustment":
      data['der'] = state.calculateDerReducer.data.der;
      data['cbw'] = state.bodyConditionReducer.selectedBodyWeight;
      break;

    case "maintenance":
      data['der'] = state.calculateDerReducer.data.der;
      break;
  }
  
  return data;
}

/**
 * Returns the number of weeks between todays date and the pet birthdate
 */
function getAgeInWeeks(birthDate){
  if (!birthDate){
    return 1;
  }
  
  const today = moment()
  const birthday = moment(birthDate, 'YYYY/MM/DD');
  let diff = today.diff(birthday, 'week');

  if (diff < 1){
    return 1;
  }

  return diff;

}

export default fetchFeedingGuidelinesIntro;


